import {IMembersAreaWidgetPluginService, IRouteDataService} from '@wix/members-area-widget-plugin-lib/viewer'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {createEventHandler} from '@wix/tpa-settings'
import {fetchInitialState} from './controller-utils'

interface RegisterWidgetPluginHostListenersParams {
  widgetPluginService: IMembersAreaWidgetPluginService
  routerDataService: IRouteDataService
  controllerParams: ControllerParams
  componentEventHandler: ReturnType<typeof createEventHandler>
  eventsMembersAreaV2Enabled: boolean
}

export const registerWidgetPluginHostListeners = ({
  widgetPluginService,
  routerDataService,
  controllerParams,
  componentEventHandler,
  eventsMembersAreaV2Enabled,
}: RegisterWidgetPluginHostListenersParams) => {
  widgetPluginService.onMembersAreaEvent(event => {
    switch (event.type) {
      case 'MEMBERS_CHANGED':
        return void fetchInitialState({
          controllerParams,
          componentEventHandler,
          routerDataService,
          eventsMembersAreaV2Enabled,
        })
    }
  })
}
